import React from 'react';
import { useRouter } from 'next/router';
import useShopper from '../hooks/useShopper';

export const SessionInitProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const router = useRouter();

    // IMPORTANT:
    // The app boot sequence auto-logs-in a shopper (guest/refresh) via `useShopper()`.
    // On the magiclink callback route we *must* first exchange the token, otherwise the
    // auto-login can race and trigger the standard PKCE token exchange instead.
    const path = typeof window !== 'undefined' ? (router.asPath || '').toLowerCase() : '';
    const isMagicLinkCallback = path.startsWith('/magiclink/callback');

    if (!isMagicLinkCallback) {
        useShopper();
    }
    return <>{children}</>;
};
